// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"30733e10","78":"3e133dc3","151":"15909e00","259":"abb28c16","312":"f196fb05","450":"3a1fca20","486":"57ca96bb","636":"b23d9814","653":"622a4ff0","668":"56e91d00","684":"4964b5bc","688":"b25548ec","891":"dd4048f6"}[chunkId] + ".chunk.js";
};